module.exports = __webpack_public_path__ + "img/news_detail_2_2.49a0aa5f.png";